// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__k0VRN","errorLogs":"styles_errorLogs__1CJAN"};